import React from "react";
import { Helmet } from "react-helmet-async";

function SoundHealingJourney() {    
    return (
        <div>
            <Helmet>
                <title>Sound Healing Journey | Adya Yoga</title>
                <meta
                  name="description"
                  content="Experience the power of sound and vibration for deep relaxation and balance. Explore our sound healing therapies."
                />
                <link rel="canonical" href="https://yogaadya.com/sound-healing-journey" />
                <meta name="robots" content="index, follow" />
                <meta property="og:type" content="website" />
                <meta property="og:site_name" content="Adya Yoga" />
                <meta property="og:title" content="Sound Healing Journey | Adya Yoga" />
                <meta property="og:description" content="Sound healing sessions for relaxation, balance, and well-being." />
                <meta property="og:url" content="https://yogaadya.com/sound-healing-journey" />
                <meta property="og:image" content="https://yogaadya.com/assets/images/SoundAndHealing.png" />
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:title" content="Sound Healing Journey | Adya Yoga" />
                <meta name="twitter:description" content="Experience the power of sound and vibration." />
                <meta name="twitter:image" content="https://yogaadya.com/assets/images/SoundAndHealing.png" />
            </Helmet>
            
            {/* about */}    
            <section className ="about py-lg-4 py-md-3 py-sm-3 py-3" id="intro">
            <div className="events-retreats-container">
                    {/* Header Section */}
                <div className="events-header">
                    <h1 className="events-title">Sound Healing Journey</h1>
                    <p className="events-subtitle">
                    Power of <b>Sound</b>. Power of <b>Vibrations</b>. Power of <b>Frequency</b>.
                    </p>
                </div>
                
                <div className ="row">
                    <div className ="col-lg-12 about-two-grids">                    
                    <div className="about-para-txt">                        
                        <p className="mb-4" style={{ lineHeight: '1.8', fontSize: '1.1rem' }}>
                            A session of personal Sound Journey increases spiritual well-being and a reduction
                            in tension and depressed moods. Sound healing can slow down our brain waves and
                            put our bodies in a very relaxed, dreamlike state.
                        </p>
                        
                        <h4 className="mb-3" style={{ color: '#2c3e50', fontWeight: '600' }}>Some major benefits of Sound Healing:</h4>
                        <ul className="benefits-list" style={{ 
                            listStyle: 'none', 
                            paddingLeft: '0',
                            marginBottom: '2rem'
                        }}>
                            <li className="mb-2" style={{ 
                                paddingLeft: '1.5rem', 
                                position: 'relative',
                                lineHeight: '1.6'
                            }}>
                                <span style={{ 
                                    position: 'absolute', 
                                    left: '0', 
                                    color: '#e67e22'
                                }}>•</span>
                                Relief from Pain &amp; Discomfort
                            </li>
                            <li className="mb-2" style={{ 
                                paddingLeft: '1.5rem', 
                                position: 'relative',
                                lineHeight: '1.6'
                            }}>
                                <span style={{ 
                                    position: 'absolute', 
                                    left: '0', 
                                    color: '#e67e22'
                                }}>•</span>
                                Relief from Insomnia, Anxiety, Stress
                            </li>
                            <li className="mb-2" style={{ 
                                paddingLeft: '1.5rem', 
                                position: 'relative',
                                lineHeight: '1.6'
                            }}>
                                <span style={{ 
                                    position: 'absolute', 
                                    left: '0', 
                                    color: '#e67e22'
                                }}>•</span>
                                Improved Blood Circulation and Nerve functions
                            </li>
                            <li className="mb-2" style={{ 
                                paddingLeft: '1.5rem', 
                                position: 'relative',
                                lineHeight: '1.6'
                            }}>
                                <span style={{ 
                                    position: 'absolute', 
                                    left: '0', 
                                    color: '#e67e22'
                                }}>•</span>
                                Healing of common ailments like:
                                <ul style={{ 
                                    listStyle: 'none', 
                                    paddingLeft: '1.5rem',
                                    marginTop: '0.5rem'
                                }}>
                                    <li style={{ color: '#666' }}>• Joint Pain, Arthritis</li>
                                    <li style={{ color: '#666' }}>• Migraine, Headache</li>
                                    <li style={{ color: '#666' }}>• Digestive Disorders</li>
                                    <li style={{ color: '#666' }}>• Neck &amp; Shoulder Tension</li>
                                    <li style={{ color: '#666' }}>• Lower Back Pain</li>
                                </ul>
                            </li>
                        </ul>

                        <p className="highlight-text" style={{ 
                            fontSize: '1.2rem', 
                            fontWeight: '500',
                            color: '#2c3e50',
                            lineHeight: '1.8',
                            fontStyle: 'italic'
                        }}>
                            If you are someone seeking non-invasive methods to achieve emotional balance and
                            Relaxation, then THIS IS FOR YOU.
                        </p>                        
                    </div>          
                    </div>
                </div>
                <div className ="row">
                    <div className ="col-lg-12 about-imgs-txt text-center">
                    <img 
                        src="assets/images/SoundAndHealing.png" 
                        alt="news image" 
                        className ="img-fluid"
                        style={{
                            maxWidth: '100%',
                            height: 'auto',
                            display: 'inline-block'
                        }}
                    />
                    </div>        
                </div>                
                </div>
            </section>
            <section class="py-md-3 py-sm-3 py-3" id="healing-therapies">
  <div class="container py-lg-5 py-md-4 py-sm-4 py-3">
    <h3 className="text-center title mb-4">Various Sound Healing Therapies</h3>
     {/*  Sampoorna */}
     <div class="therapy-item">
      {/* <img src="assets/images/reiki-healing.webp" alt="Therapy 6" class="therapy-img"/> */}
      <div class="therapy-content">
        <h4>Sampoorna.</h4>
        <p>   Full Mind Body Relaxation with Vibrations.       
        </p>
      </div>
    </div>


    {/*  Sapta Chakra. */}
    <div class="therapy-item">
      {/* <img src="assets/images/reiki-healing.webp" alt="Therapy 6" class="therapy-img"/> */}
      <div class="therapy-content">
        <h4>Sapta Chakra.</h4>
        <p> Chakra Healing and Balancing.
        Working with your 7 main energy centres.         
        </p>
      </div>
    </div>

    {/*  Mana Shuddhi. */}
    <div class="therapy-item">
      {/* <img src="assets/images/reiki-healing.webp" alt="Therapy 6" class="therapy-img"/> */}
      <div class="therapy-content">
        <h4>Mana Shuddhi.</h4>
        <p> Mind Detoxification Therapy.
        If you have had too much going on and want help with mental traffic.         
        </p>
      </div>
    </div>

    {/*  Reflex Zones Therapy. */}
    <div class="therapy-item">
      {/* <img src="assets/images/reiki.webp" alt="Therapy 6" class="therapy-img"/> */}
      <div class="therapy-content">
        <h4>Reflex Zones Therapy.</h4>
        <p>   In this Therapy we work on our main areas of our body
        which carry major Marma/Pressure Points, for example Feet, Hands, Spine etc.       
        </p>
      </div>
    </div>

    {/*  Soul Healing. */}
    <div class="therapy-item">
      {/* <img src="assets/images/reiki-healing.webp" alt="Therapy 6" class="therapy-img"/> */}
      <div class="therapy-content">
        <h4>Soul Healing.</h4>
        <p>  This is customised as per what you need. This a combination of
        Energy Reading followed by a Sound Journey.        
        </p>
      </div>
    </div>


    {/*  Group Sound Healing Journeys*/}
    <div class="therapy-item">    
        {/* <img src="assets/images/reiki-healing.webp" alt="Therapy 6" class="therapy-img"/> */}  
      <div class="therapy-content">
        <h4>Group Sound Healing Journeys</h4>
        <p>  It is a great experience to facilitate a group with potent healing powers pf Sound &amp;
Vibrations. This can be organinsed for a small group of friends/family or even for a
larger group of people.
Ask for more details via Email or Whatsapp.
        </p>
      </div>
    </div>

    </div>
    </section>                        
        </div>
    )
}

export default SoundHealingJourney;